import axiosApiInstance from "../app/axios";
import { CAMPAIGN_API_BASE_URL } from "../app/utils";

const base = () => `${CAMPAIGN_API_BASE_URL}/api/v1/campaigns`;

export const getCampaigns = async () => axiosApiInstance.get(base());

export const getTemplateRules = async () => axiosApiInstance.get(`${base()}/template-rules`);

export const getCampaign = async (id) => axiosApiInstance.get(`${base()}/${id}`);

export const createCampaign = async (campaign) =>
  axiosApiInstance.post(base(), campaign);

export const updateCampaign = async (id, campaign) =>
  axiosApiInstance.put(`${base()}/${id}`, campaign);

export const materialiseAudience = async (id) =>
  axiosApiInstance.post(`${base()}/${id}/audience`, {});

export const sendTestCampaign = async (id, email, firstName) =>
  axiosApiInstance.post(`${base()}/${id}/test`, { email, firstName });

export const sendCampaign = async (id) =>
  axiosApiInstance.post(`${base()}/${id}/send`, {});

export const raiseCampaignCap = async (id, limit) =>
  axiosApiInstance.post(`${base()}/${id}/cap`, { limit });

export const pauseCampaign = async (id) =>
  axiosApiInstance.post(`${base()}/${id}/pause`, {});

export const getCampaignStats = async (id) =>
  axiosApiInstance.get(`${base()}/${id}/stats`);

export const removeSuppression = async (email) =>
  axiosApiInstance.delete(
    `${CAMPAIGN_API_BASE_URL}/api/v1/suppressions/${encodeURIComponent(email)}`
  );

const lists = () => `${CAMPAIGN_API_BASE_URL}/api/v1/audience-lists`;

export const getAudienceLists = async () => axiosApiInstance.get(lists());

export const createAudienceList = async (list) =>
  axiosApiInstance.post(lists(), list);

export const updateAudienceList = async (id, list) =>
  axiosApiInstance.put(`${lists()}/${id}`, list);

export const deleteAudienceList = async (id) =>
  axiosApiInstance.delete(`${lists()}/${id}`);

export const getAudienceListMembers = async (id) =>
  axiosApiInstance.get(`${lists()}/${id}/members`);

export const addAudienceListMembers = async (id, userIds) =>
  axiosApiInstance.post(`${lists()}/${id}/members`, { userIds });

export const removeAudienceListMember = async (id, userId) =>
  axiosApiInstance.delete(`${lists()}/${id}/members/${encodeURIComponent(userId)}`);
